<script>
import ActionsForm from '@/shared/mixins/actionsForm'
const name = 'filterForm'

export default {
  name,
  mixins: [ ActionsForm ],
  components: { },

  props: { },

  mounted () { },

  updated () { },

  data () {
    return {
      partFilter: ''
    }
  },

  methods: {
    validateFilter () {
      const regex = /\D/gm
      if (this.partFilter.match(regex)) {
        this.partFilter = this.partFilter.match(regex).forEach(x => {
          x.replace(regex, '')
        })
      }
      this.$emit('partNumber', this.partFilter)
    }
  },

  computed: { }

}
</script>

<template>
    <div>
        <Forms class="form-class-filter"
          :ShowFooterImbo="true"
          @Search = "validateFilter"
          @Clear= "partFilter = ''"
          title="Pesquisa de Lote"
          :showSearchIcon="true"
        >
          <label for="cbxInsure">Número do Lote:</label>
          <b-input v-model="partFilter" placeholder="Insiro o Número do Lote" />
        </Forms>
    </div>
</template>
<style scoped>
.form-class-filter{
  padding: 0;
  margin: 0;
  width:  100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/CollaboratorTableTravelExpense/components/CollaboratorTableTravelExpenseEmploye/components/filterForm.vue